import { convertSubscription } from "../utils";
import {
  PaymentDetails,
  PCResponse,
  PCSubscription,
  Subscription,
} from "../../../contracts/nexar-api/types";
import { NexarApiContract } from "../../../contracts/nexar-api/nexar-api";
import NexarApi from "../actual-api/api";
import FixtureAPIGetUserSubscriptions from "./fixtures/get-user-subscriptions";
import FixtureGetSubscriptionsByIdActive from "./fixtures/get-subscriptions-by-id--active";
import FixtureGetSubscriptionsByIdPending from "./fixtures/get-subscriptions-by-id--pending";
import FixtureGetSubscriptionsByIdInactiveCancelled from "./fixtures/get-subscriptions-by-id--inactive-cancelled";
import FixtureGetSubscriptionsByIdInactivePayment from "./fixtures/get-subscriptions-by-id--inactive-payment";
import FixtureGetSubscriptionsByIdPaused from "./fixtures/get-subscriptions-by-id--paused";
import FixtureAPIGetUserSubscriptionsEmpty from "./fixtures/get-user-subscriptions-empty";
import stripe from "stripe";
import FixtureGetSubscriptionsByIdActivePrepaid from "./fixtures/get-subscriptions-by-id--active-prepaid";
import FixtureGetSubscriptionsByIdActiveTrial from "./fixtures/get-subscriptions-by-id--active-trial";
import { string } from "yup";

const RETURN_EMPTY = false;
const IS_AUTHENTICATED = true;
const FAIL_CANCELLATION = true;
const FAIL_UPDATE = true;
const FAIL_ACTIVATION = true;
const FAIL_SETUP_INTENT_CREATION = true;

const getSubscriptionsWithModules = async (): Promise<{
  data: Subscription[] | null;
}> => {
  let data = FixtureAPIGetUserSubscriptions;
  if (RETURN_EMPTY) {
    data = FixtureAPIGetUserSubscriptionsEmpty;
  }

  const subscriptions = data.payload.subscriptions as PCSubscription[];
  const convertedSubscriptions = subscriptions?.map((sub: PCSubscription) =>
    convertSubscription(sub)
  );
  return { data: convertedSubscriptions || null };
};

const getSubscriptionById = async ({
  subscriptionId,
}: {
  subscriptionId: string;
}): Promise<{ data: Subscription }> => {
  let payload;
  switch (subscriptionId) {
    case "TEST-ID-INACTIVE-CANCELLED":
      payload = FixtureGetSubscriptionsByIdInactiveCancelled.payload;
      break;
    case "TEST-ID-INACTIVE-PAYMENT":
      payload = FixtureGetSubscriptionsByIdInactivePayment.payload;
      break;
    case "TEST-ID-PENDING":
      payload = FixtureGetSubscriptionsByIdPending.payload;
      break;
    case "TEST-ID-PAUSED":
      payload = FixtureGetSubscriptionsByIdPaused.payload;
      break;
    case "TEST-ID-ACTIVE-PREPAID":
      payload = FixtureGetSubscriptionsByIdActivePrepaid.payload;
      break;
    case "TEST-ID-ACTIVE_TRIAL":
      payload = FixtureGetSubscriptionsByIdActiveTrial.payload;
      break;
    case "TEST-ID-ACTIVE":
    default:
      payload = FixtureGetSubscriptionsByIdActive.payload;
      break;
  }

  const convertedSubscription = convertSubscription(
    payload?.subscription as PCSubscription
  );
  return { data: convertedSubscription };
};

async function validateOtpCodeAndLogin(
  countryCode: string,
  phoneNumber: string,
  digits: string,
  clientId: string
): Promise<any> {}

async function sendOtpCode(
  countryCode: string,
  phoneNumber: string
): Promise<{ clientId: string }> {
  const clientId = new Date().getTime().toString();
  return { clientId: clientId };
}

async function isAuthenticated(): Promise<boolean> {
  return Promise.resolve(IS_AUTHENTICATED);
}

async function createSubscriptionSetupIntent({
  subscriptionId,
}: {
  subscriptionId: string;
}): Promise<{ clientSecret: string }> {
  if (FAIL_SETUP_INTENT_CREATION) {
    throw new Error("Failed to create setup intent");
  }
  const client = new stripe("sk_test_kSkhZI96sfcixae8JstiaH7D");
  const setupIntent = await client.setupIntents.create({
    usage: "off_session",
  });

  return { clientSecret: setupIntent.client_secret || "" };
}
const deleteSubscriptionById = async ({
  subscriptionId,
}: {
  subscriptionId: string;
}): Promise<PCResponse> => {
  if (FAIL_CANCELLATION) {
    return { error: {}, payload: {} };
  } else {
    return { success: {}, payload: {} };
  }
};

const updateSubscriptionById = async ({
  subscriptionId,
  paymentDetails,
}: {
  subscriptionId: string;
  paymentDetails: PaymentDetails;
}): Promise<PCResponse> => {
  if (FAIL_UPDATE) {
    return { error: {}, payload: {} };
  } else {
    return { success: {}, payload: {} };
  }
};

const activateSubscriptionById = async ({
  subscriptionId,
  paymentDetails,
}: {
  subscriptionId: string;
  paymentDetails: PaymentDetails;
}): Promise<PCResponse> => {
  if (FAIL_ACTIVATION) {
    return { error: {}, payload: {} };
  } else {
    return { success: {}, payload: {} };
  }
};

const getUserData = async () => {
  return {};
};
const getPersonalCloudUserId = () => {
  return "test_pc_user_id";
};
const getRxdaemonUserId = () => {
  return "test_rx_user_id";
};

const MockNexarApi: NexarApiContract = {
  ...NexarApi,
  getSubscriptionById,
  getSubscriptionsWithModules,
  sendOtpCode,
  validateOtpCodeAndLogin,
  activateSubscriptionById,
  isAuthenticated,
  createSubscriptionSetupIntent,
  deleteSubscriptionById,
  updateSubscriptionById,
  getUserData,
  getPersonalCloudUserId,
  getRxdaemonUserId,
};
export default MockNexarApi;
